import React from 'react'
import { all, call, put, select, takeEvery } from 'redux-saga/effects'

import { trackJobmailActivation } from '@/tracking'

import { toast } from '../../notifications'
import NotificationMessage from '../../notifications/components/NotificationMessage'
import { getReducedSearchState } from '../../search/store/selectors'
import { api } from '../../services'
import {
  GTM_EVENT_USER_INTERACTION_LABEL_JOBMAIL_FORM_SLIDE_SENT,
  GTM_EVENT_USER_INTERACTION_LABEL_JOBMAIL_POPUP_SENT
} from '../../tracking/constants'
import { selectors as user } from '../../user'
import { stringify } from '../../utils/locationConverter'
import SuccessNotificationMessage from '../components/SuccessNotificationMessage'
import { GENERIC_ERROR_MESSAGE, SUCCESSFULLY_ACTIVATED_MESSAGE } from '../constants'

import {
  subscribe,
  subscribeSuccess,
  subscribeFailure,
  resendActivation
} from './actions'
import { getOpenSearchJobmailDueToScroll } from './selectors'

export function * apiRequest (request) {
  const authenticated = yield select(user.isLoggedIn)
  const apiCall = authenticated ? api.subscribeJobmailAuth : api.subscribeJobmail
  const {
    data: {
      success,
      activation_email_sent: activationSent,
      errors
    }
  } = yield call(apiCall, request)
  try {
    if (success) {
      if (authenticated) {
        toast.success(<NotificationMessage message={SUCCESSFULLY_ACTIVATED_MESSAGE} />)
      } else {
        toast.success(<SuccessNotificationMessage email={request.email} showResendLink={activationSent} />)
      }
      yield put(subscribeSuccess())
      const openDueToScroll = yield select(getOpenSearchJobmailDueToScroll)
      if (openDueToScroll) {
        trackJobmailActivation(GTM_EVENT_USER_INTERACTION_LABEL_JOBMAIL_FORM_SLIDE_SENT)
      } else {
        trackJobmailActivation(GTM_EVENT_USER_INTERACTION_LABEL_JOBMAIL_POPUP_SENT)
      }
    } else {
      yield put(subscribeFailure({ errors }))
    }
  } catch (e) {
    yield put(subscribeFailure({ message: GENERIC_ERROR_MESSAGE }))
  }
}

export function * createSubscription ({ payload: { email, dataConsent } }) {
  const query = yield select(getReducedSearchState) || {}
  const data = { hash: stringify(query), email, data_policy: dataConsent }
  yield call(apiRequest, data)
}

export function * resendActivationEmail ({ payload: email }) {
  const SUCCESS_TITLE = 'Fast geschafft'
  const SUCCESS_TEXT = `
        Wir haben Ihnen die Bestätigungsmail erneut an ${email} gesendet.
        Bitte bestätigen Sie Ihre E-Mail-Adresse durch Anklicken des Links in der E-Mail.`
  const message = { title: SUCCESS_TITLE, text: SUCCESS_TEXT }
  try {
    const { data: { success } } = yield call(api.resendJobmailActivationEmail, { email })
    if (success) {
      toast.success(<NotificationMessage message={message} />)
    } else {
      toast.error(GENERIC_ERROR_MESSAGE)
    }
  } catch (e) {
    toast.error(GENERIC_ERROR_MESSAGE)
  }
}

export default all([
  takeEvery(subscribe, createSubscription),
  takeEvery(resendActivation, resendActivationEmail)
])
